import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function RadioOffIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 22 22' ?? viewBox;
    const newColorProps = style.color ?? '#E0E1E3';
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <circle cx="11" cy="11" r="10" stroke={newColorProps} strokeWidth="2" />
        </Icon>
    );
}
